import { Box, useDisclosure } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { User } from "@nens/rana/api-v1";
import { RanaModal, RanaTable } from "@nens/ranalib";

import { TableEmptyUserOrInvite } from "@/components/table-empty-user-or-invite";
import { nameColumnString } from "@/translations";
import { getCompleteName } from "@/utils/get-complete-name";

import { Profile } from "../profile";

export function ProfileListModal({
  users,
  noModal,
  children,
}: PropsWithChildren<{ users?: User[]; noModal?: boolean }>) {
  const intl = useIntl();
  const { isOpen, onOpen, onClose } = useDisclosure();
  if (!users || noModal) return children;
  return (
    <>
      <Box
        onClick={(event) => {
          event.stopPropagation();
          onOpen();
        }}
        cursor="pointer"
      >
        <Box _hover={{ textDecor: "underline" }}>{children}</Box>
      </Box>
      <RanaModal
        isOpen={isOpen}
        onClose={onClose}
        topBar={<FormattedMessage id="tab.users" defaultMessage="Users" />}
        maxW="xl"
        pb={8}
      >
        <RanaTable
          columnDefinitions={[
            {
              title: "",
              width: "table_cell_xxxs",
            },
            {
              title: nameColumnString(intl),
              orderingField: "given_name",
              width: "table_cell",
            },
          ]}
          tableDataIds={users.map((user) => user.id)}
          emptyElement={<TableEmptyUserOrInvite />}
        >
          <RanaTable.Container minH="full">
            <RanaTable.Header />
            <RanaTable.Body>
              {users.map((user) => (
                <RanaTable.Row key={user.id} rowId={user.id} w="full" m={0}>
                  <RanaTable.Cell>
                    <Profile inTable user={user} />
                  </RanaTable.Cell>
                  <RanaTable.Cell>{getCompleteName(user)}</RanaTable.Cell>
                </RanaTable.Row>
              ))}
            </RanaTable.Body>
          </RanaTable.Container>
        </RanaTable>
      </RanaModal>
    </>
  );
}
